module.exports = __webpack_public_path__ + "static/media/logo-icon-only.6c87bb98.svg";